import { render, staticRenderFns } from "./EmailActions.vue?vue&type=template&id=1790a310&scoped=true&"
import script from "./EmailActions.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmailActions.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EmailActions.vue?vue&type=style&index=0&id=1790a310&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1790a310",
  null
  
)

export default component.exports